import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bae01d22")

_pushScopeId("data-v-bae01d22")
const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "my-4 pt-4" }
const _hoisted_3 = { class: "flex flex-row gap-3 overflow-hidden pb-6" }
const _hoisted_4 = {
  class: "sticky top-0 left-0 pl-2 pb-6 flex flex-col gap-y-4",
  style: {"max-width":"364px"}
}
const _hoisted_5 = {
  class: "flex flex-col gap-3 overflow-auto max-h-screen h-full",
  style: {"flex":"2","padding-bottom":"200px"}
}
const _hoisted_6 = { class: "flex flex-row justify-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_InfoDetailClient = _resolveComponent("InfoDetailClient")!
  const _component_ClientRateHistory = _resolveComponent("ClientRateHistory")!
  const _component_ConfirmationApprovalRejectClient = _resolveComponent("ConfirmationApprovalRejectClient")!
  const _component_InfoPriceClient = _resolveComponent("InfoPriceClient")!
  const _component_RenewalRateCard = _resolveComponent("RenewalRateCard")!
  const _component_ClientDetailCardParent = _resolveComponent("ClientDetailCardParent")!
  const _component_ClientDetailCardBranch = _resolveComponent("ClientDetailCardBranch")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_PriceTypeForm = _resolveComponent("PriceTypeForm")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Breadcrumb)
    ]),
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.fetchDetail,
      title: _ctx.title,
      fullPage: "",
      verticalSeparator: false
    }, {
      data: _withId(() => [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_InfoDetailClient, {
              balance: _ctx.balance,
              clientName: _ctx.detailData.clientName,
              clientStatus: _ctx.detailData.clientStatus,
              createdAt: _ctx.createdAt,
              createdBy: _ctx.detailData.clientCreatedBy,
              updatedAt: _ctx.updatedAt,
              updatedBy: _ctx.detailData.clientUpdatedBy,
              isClientParent: _ctx.isParent,
              showBalance: _ctx.isParent,
              clientFreeze: _ctx.detailData.clientFreeze,
              rateUpdatedAt: _ctx.detailData.rateUpdatedAt,
              rateUpdatedBy: _ctx.detailData.rateUpdatedBy,
              detailUpdatedBy: _ctx.detailData.newestUpdatedDetail.updatedByName,
              detailUpdatedAt: _ctx.detailData.newestUpdatedDetail.updatedAt,
              freezeReason: _ctx.detailData.clientBannedReason,
              freezeUpdatedAt: _ctx.updatedAt,
              freezeUpdatedBy: _ctx.detailData.clientUpdatedBy
            }, null, 8, ["balance", "clientName", "clientStatus", "createdAt", "createdBy", "updatedAt", "updatedBy", "isClientParent", "showBalance", "clientFreeze", "rateUpdatedAt", "rateUpdatedBy", "detailUpdatedBy", "detailUpdatedAt", "freezeReason", "freezeUpdatedAt", "freezeUpdatedBy"]),
            (_ctx.showClientRateHistory)
              ? (_openBlock(), _createBlock(_component_ClientRateHistory, {
                  key: 0,
                  detailData: _ctx.detailData
                }, null, 8, ["detailData"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_5, [
            (_ctx.isRequested && !_ctx.isPeriodApproval && _ctx.isApprovalEnable)
              ? (_openBlock(), _createBlock(_component_ConfirmationApprovalRejectClient, {
                  key: 0,
                  approvalType: "renewal",
                  clientType: _ctx.isParent ? _ctx.$t('clientManagement.managementList.parentClient').toString().toLowerCase() : _ctx.$t('clientManagement.managementList.branchClient').toString().toLowerCase(),
                  id: _ctx.detailData.clientRenewalRate.clientCustomRateId,
                  clientName: _ctx.detailData.clientName,
                  errorMessage: _ctx.errorMessage,
                  onSuccessReject: _ctx.fetchDetail,
                  onSuccessApprove: _ctx.fetchDetail
                }, null, 8, ["clientType", "id", "clientName", "errorMessage", "onSuccessReject", "onSuccessApprove"]))
              : (_ctx.isPeriodApproval)
                ? (_openBlock(), _createBlock(_component_ConfirmationApprovalRejectClient, {
                    key: 1,
                    approvalType: "period",
                    clientType: _ctx.isParent ? _ctx.$t('clientManagement.managementList.parentClient').toString().toLowerCase() : _ctx.$t('clientManagement.managementList.branchClient').toString().toLowerCase(),
                    id: _ctx.detailData.clientRatePeriodChange.rateVersionId,
                    clientName: _ctx.detailData.clientName,
                    errorMessage: "",
                    onSuccessReject: _ctx.fetchDetail,
                    onSuccessApprove: _ctx.fetchDetail
                  }, null, 8, ["clientType", "id", "clientName", "onSuccessReject", "onSuccessApprove"]))
                : _createCommentVNode("", true),
            (_ctx.isParent)
              ? (_openBlock(), _createBlock(_component_InfoPriceClient, {
                  key: 2,
                  isManagement: true
                }))
              : _createCommentVNode("", true),
            (_ctx.isParent && _ctx.clientStatus !== 'pending')
              ? (_openBlock(), _createBlock(_component_RenewalRateCard, {
                  key: 3,
                  detailData: _ctx.detailData,
                  onRenewRate: _ctx.onRenewRate,
                  onCancelUploadRate: _ctx.fetchDetail
                }, null, 8, ["detailData", "onRenewRate", "onCancelUploadRate"]))
              : _createCommentVNode("", true),
            (_ctx.isParent)
              ? (_openBlock(), _createBlock(_component_ClientDetailCardParent, {
                  key: 4,
                  detailData: _ctx.detailData,
                  isManagement: true,
                  title: _ctx.$t('clientManagement.managementDetail.parentDetailTitle')
                }, null, 8, ["detailData", "title"]))
              : (_openBlock(), _createBlock(_component_ClientDetailCardBranch, {
                  key: 5,
                  isManagement: true,
                  title: _ctx.$t('clientManagement.managementDetail.branchDetailTitle')
                }, null, 8, ["title"]))
          ])
        ])
      ]),
      _: 1
    }, 8, ["onBack", "loading", "error", "errorType", "onTryAgain", "title"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.submitRenewRate,
      onClose: _ctx.closeRenewRateConfirmation,
      title: _ctx.$t('clientManagement.infoPriceClient.changeParentClientPriceQuestion'),
      message: _ctx.$t('clientManagement.infoPriceClient.changeParentClientPriceMessage'),
      image: "badge-confirmation-general",
      textSuccess: _ctx.$t('clientManagement.infoPriceClient.yesChange'),
      textCancel: _ctx.$t('clientManagement.infoPriceClient.back'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.isRenewRateConfirmation]
    ]),
    (_ctx.renewRateDialog)
      ? (_openBlock(), _createBlock(_component_ModalV2, {
          key: 0,
          width: "w-10/12",
          title: _ctx.$t('clientManagement.infoPriceClient.changeParentClientPrice'),
          showFooter: true,
          onClose: 
        () => {
          _ctx.renewRateDialog = false;
          _ctx.onResetForm();
        }
      
        }, {
          content: _withId(() => [
            _createVNode(_component_PriceTypeForm, {
              modelValue: _ctx.form,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form = $event)),
              error: _ctx.error,
              "onUpdate:error": _cache[2] || (_cache[2] = ($event: any) => (_ctx.error = $event)),
              customPriceOption: _ctx.customPriceOption
            }, null, 8, ["modelValue", "error", "customPriceOption"])
          ]),
          footer: _withId(() => [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_LpButton, {
                title: _ctx.$t('clientManagement.infoPriceClient.save'),
                textColor: "white",
                disabled: !_ctx.isValidRenewRate,
                onClick: _ctx.renewRate
              }, null, 8, ["title", "disabled", "onClick"])
            ])
          ]),
          _: 1
        }, 8, ["title", "onClose"]))
      : _createCommentVNode("", true)
  ]))
})